import { render, staticRenderFns } from "./PointbackSettingDescription.vue?vue&type=template&id=2aa9bcc6&scoped=true"
import script from "./PointbackSettingDescription.vue?vue&type=script&lang=js"
export * from "./PointbackSettingDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa9bcc6",
  null
  
)

export default component.exports